export default __webpack_public_path__ + "static/media/circle-check-blurple.efbfccbf.svg";